import { FC } from 'react';

import { CountryEntity } from 'api/types/entity';
import { useFormErrorFocus } from 'hooks';
import { useTranslation } from 'libs/i18n';
import { Stack } from 'libs/ui';
import {
  ReasonAddSection,
  CompanyRegistrationAndResidentialAddressSection,
  CompanyStateRegistrationSection,
  ContactsSection,
} from 'modules/client/common/components/sections';
import { CompanyTaxResidencySection } from 'modules/client/legal/components/sections';
import { LegalClientBranchNameSection } from 'modules/client/legalClientBranch/components/sections';

export interface LegalClientAddBranchSectionsProps {
  countriesLoading?: boolean;
  countries: CountryEntity[];
}

export const LegalClientAddBranchSections: FC<
  LegalClientAddBranchSectionsProps
> = ({ countries, countriesLoading }) => {
  const { t } = useTranslation();

  useFormErrorFocus('center');

  return (
    <Stack spacing={24}>
      <ReasonAddSection />

      <LegalClientBranchNameSection />

      <CompanyTaxResidencySection
        countries={countries}
        countriesLoading={countriesLoading}
      />

      <CompanyStateRegistrationSection hideDocuments />

      <CompanyRegistrationAndResidentialAddressSection
        countries={countries}
        countriesLoading={countriesLoading}
        title={t('client.legal.legalClientBranch.address.title')}
      />

      <ContactsSection
        isEditAllowed
        title={t('client.legal.legalClientBranch.contacts.title')}
      />
    </Stack>
  );
};
